import { Attribute, FieldType } from "../../../../../model/service-request/attribute";
import { DynamicFieldItem } from "../../../../../model/dynamic-forms";
import { Money } from "../../../../../model/common/money";

export function getFieldPathSuffix(fieldType: FieldType, isMulti = false): string {
	switch (fieldType) {
		case FieldType.Text:
		case FieldType.TextDescription:
			return "stringValue";
		case FieldType.Number:
			return "doubleValue";
		case FieldType.Bool:
			return "boolValue";
		case FieldType.Dropdown:
		case FieldType.SingleSelect:
		case FieldType.ConditionalDropdown:
		case FieldType.ChildDropdown:
			return isMulti ? "selectedOptionIds" : "selectedOptionIds[0]";
		case FieldType.MultiSelect:
			return "selectedOptionIds";
		case FieldType.DateTime:
			return "dateValue";
		case FieldType.File:
			return "file";
		case FieldType.Image:
			return "image";
		default:
			return "stringValue";
	}
}

type BuildDynamicFieldItemArgs = {
	attribute: Attribute;
	fieldValue: any;
	isMulti?: boolean;
	selectedChildId?: string;
	selectedChildIds?: string[];
	dropdownText?: string;
	price?: Money;
	fileFileName?: string;
};

export function buildDynamicFieldItem(args: BuildDynamicFieldItemArgs): DynamicFieldItem {
	const { attribute, fieldValue, isMulti, selectedChildId, selectedChildIds, dropdownText, price, fileFileName } = args;
	const suffix = getFieldPathSuffix(attribute.fieldType!, isMulti);
	return {
		fieldId: attribute.id,
		fieldLabel: attribute.placeholderText || attribute.label,
		fieldValue,
		fieldType: attribute.fieldType!,
		fieldPath: `${attribute.id}.${suffix}`,
		selectedChildId,
		selectedChildIds,
		dropdownText,
		price,
		fileFileName,
	};
}
